// Module
var code = " <button mat-icon-button=\"\" type=\"button\" (click)=\"onClick()\" matTooltip=\"{{'lbl_clear' | translate}}\" [hidden]=\"!canClear || control?.disabled\"> <mat-icon svgIcon=\"gh:close\" class=\"s16\"></mat-icon> </button>";
// Exports
module.exports = code;